<template>
  <!-- Desktop version -->
  <div v-if="visible && $vuetify.breakpoint.mdAndUp" class="chat-container">
    <v-card class="d-flex flex-column chat-card elevation-10">
      <!-- Header -->
      <v-toolbar dense flat color="primary" dark>
        <v-avatar size="28" class="mr-2">
          <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="avatar">
        </v-avatar>
        <v-toolbar-title class="text-subtitle-2 font-weight-medium">
          Jason Oner
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="minimized = !minimized">
          <v-icon>{{ minimized ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        <v-btn icon small @click="showChat">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Messages -->
      <div v-show="!minimized" ref="history" class="messages-area">
        <div
          v-for="(msg, i) in messages"
          :key="i"
          class="message"
          :class="msg.from === 'me' ? 'me' : 'other'"
        >
          <v-avatar v-if="msg.from !== 'me'" size="28" class="mr-2">
            <img :src="msg.avatar" alt="avatar">
          </v-avatar>
          <v-sheet
            :color="msg.from === 'me' ? 'primary lighten-4' : 'grey lighten-3'"
            class="pa-2 rounded-lg"
            elevation="0"
          >
            <div class="text-body-2">{{ msg.text }}</div>
          </v-sheet>
          <v-avatar v-if="msg.from === 'me'" size="28" class="ml-2">
            <img :src="msg.avatar" alt="avatar">
          </v-avatar>
        </div>
      </div>

      <!-- Composer -->
      <div v-show="!minimized" class="pa-2">
        <v-text-field
          v-model="draft"
          dense
          outlined
          rounded
          placeholder="Type your message..."
          hide-details
          clearable
          @keydown.enter.exact.prevent="send"
        >
          <template v-slot:append-outer>
            <v-btn color="primary" small rounded @click="send" :disabled="!draft.trim()">
              Send
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </v-card>
  </div>

  <!-- Mobile version -->
  <div v-else-if="visible && $vuetify.breakpoint.smAndDown" class="chat-mobile">
    <!-- Floating avatar button when minimized -->
    <v-btn
      v-if="minimized"
      fab
      small
      class="chat-toggle-btn"
      :style="{ left: position.x + 'px', top: position.y + 'px' }"
      @touchstart="startDrag"
      @touchmove.prevent="onDrag"
      @touchend="endDrag"
      @click="minimized = false"
    >
      <v-avatar size="36">
        <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="avatar">
      </v-avatar>
    </v-btn>

    <!-- Chat card when expanded -->
    <v-card
      v-else
      class="chat-card-mobile elevation-10 d-flex flex-column"
    >
      <v-toolbar dense flat color="primary" dark>
        <v-avatar size="28" class="mr-2">
          <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="avatar">
        </v-avatar>
        <v-toolbar-title class="text-subtitle-2 font-weight-medium">
          Jason Oner
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="minimized = true">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <v-btn icon small @click="showChat">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Messages -->
      <div ref="history" class="messages-area">
        <div
          v-for="(msg, i) in messages"
          :key="i"
          class="message"
          :class="msg.from === 'me' ? 'me' : 'other'"
        >
          <v-avatar v-if="msg.from !== 'me'" size="28" class="mr-2">
            <img :src="msg.avatar" alt="avatar">
          </v-avatar>
          <v-sheet
            :color="msg.from === 'me' ? 'primary lighten-4' : 'grey lighten-3'"
            class="pa-2 rounded-lg"
            elevation="0"
          >
            <div class="text-body-2">{{ msg.text }}</div>
          </v-sheet>
          <v-avatar v-if="msg.from === 'me'" size="28" class="ml-2">
            <img :src="msg.avatar" alt="avatar">
          </v-avatar>
        </div>
      </div>

      <!-- Composer -->
      <div class="pa-2">
        <v-text-field
          v-model="draft"
          dense
          outlined
          rounded
          placeholder="Type your message..."
          hide-details
          clearable
          @keydown.enter.exact.prevent="send"
        >
          <template v-slot:append-outer>
            <v-btn color="primary" small rounded @click="send" :disabled="!draft.trim()">
              Send
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ChatBox',
  data: () => ({
    minimized: true,  // start minimized so avatar shows
    draft: '',
    position: { x: 340, y: window.innerHeight - 300}, // initial position from bottom-right
    dragging: false,
    startX: 0,
    startY: 0,
    messages: [
      {
        from: 'other',
        text: 'Hello! 👋 How can I help you today?',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
      },
      {
        from: 'me',
        text: 'Hi, I just wanted to ask about my order status.',
        avatar: 'https://randomuser.me/api/portraits/men/12.jpg'
      },
      {
        from: 'other',
        text: 'Of course! Could you please share your order number?',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
      }
    ],
    recent: [
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
        title: 'Jason Oner',
      },
      {
        active: true,
        avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
        title: 'Mike Carlson',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
        title: 'Cindy Baker',
      },
      {
        avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
        title: 'Ali Connors',
      },
    ],
    previous: [
      {
        title: 'Travis Howard',
        avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
      },
    ],
  }),
  props: {
    visible: { type: Boolean, default: true }
  },
  computed: {
    ...mapState({
      dialog: state => state.isDialogOpen
    }),
    // Change height with different screen size
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 600;
        case 'sm': return 600;
        case 'md': return 69;
        case 'lg': return 69;
        case 'xl': return 69;
        default: return 190;
      }
    }  
  },
  methods: {
    // Dragging feature 
    startDrag(e) {
      this.dragging = true
      this.startX = e.touches[0].clientX - this.position.x
      this.startY = e.touches[0].clientY - this.position.y
    },
    onDrag(e) {
      if (!this.dragging) return
      const x = e.touches[0].clientX - this.startX
      const y = e.touches[0].clientY - this.startY
      this.position.x = Math.max(0, Math.min(window.innerWidth - 60, x))
      this.position.y = Math.max(0, Math.min(window.innerHeight - 60, y))
    },
    endDrag() {
      this.dragging = false
    },
    send () {
      if (!this.draft.trim()) return
      const text = this.draft.trim()
      this.messages.push({
        from: 'me',
        text,
        avatar: 'https://randomuser.me/api/portraits/men/12.jpg'
      })
      this.draft = ''
      this.$nextTick(this.scrollToBottom)
    },
    receive (text) {
      this.messages.push({
        from: 'other',
        text,
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
      })
      this.$nextTick(this.scrollToBottom)
    },
    scrollToBottom () {
      const el = this.$refs.history
      if (el) el.scrollTop = el.scrollHeight
    },
    ...mapMutations({
      setDialog: 'setDialog'
    }),
    showChat () {
      this.setDialog()
    }
  }
}
</script>

<style scoped>
/* Desktop */
.chat-container {
  position: fixed;
  max-height: 480px;
  right: 20px;
  bottom: 0px;
}

.chat-card {
  width: 320px;
  max-height: 480px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
}

/* Mobile */
.chat-mobile {
  position: fixed;
  bottom: 0px;
  z-index: 2000;
}

.chat-card-mobile {
  max-height: 480px;
  width: 100vw;
  border-radius: 16px;
  overflow: hidden;
}

.chat-toggle-btn {
  position: fixed;
  right: 16px;
  bottom: 180px;
  background: white;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
}

.messages-area {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  background: #fafafa;
}

.message {
  display: flex;
  align-items: flex-end;
  margin: 6px 0;
}
.message.me {
  justify-content: flex-end;
}
.message.other {
  justify-content: flex-start;
}
</style>
